import { render, staticRenderFns } from "./QuestionFeedbackDialog.vue?vue&type=template&id=296212c0&scoped=true"
import script from "./QuestionFeedbackDialog.vue?vue&type=script&lang=js"
export * from "./QuestionFeedbackDialog.vue?vue&type=script&lang=js"
import style0 from "./QuestionFeedbackDialog.vue?vue&type=style&index=0&id=296212c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296212c0",
  null
  
)

export default component.exports